import { FC, ReactElement, cloneElement } from 'react'

interface TourTargetProps {
  target?: string | null
  children: ReactElement
}

export const TourTarget: FC<TourTargetProps> = ({ target, children }) => {
  if (!target) {
    return children
  }

  return cloneElement(children, {
    'data-tour-target': target,
  } as typeof children extends ReactElement<infer P> ? P & { 'data-tour-target': string } : { 'data-tour-target': string })
}
